import { Text } from './Text';
import { Tooltip } from './Tooltip';

export const CustodyId = ({ value }: { value?: string | null }) => {
    return value && value.length > 0 ? (
        <Tooltip tooltip={value}>
            <Text>x{value.slice(-4)}</Text>
        </Tooltip>
    ) : null;
};
